// Common events
export const CONNECTED = 'connected';
export const NOTED = 'noted';
export const NOTIFICATIONS_ACCEPTED = 'notifications_accepted';
export const NOTIFICATIONS_REFUSED = 'notifications_refused';

// Customer events
export const BOOKING_CANCELLED = 'booking_cancelled';
export const BOOKING_CREATED = 'booking_created';
export const BOOKING_CREATED_ALL = 'booking_created_all';
export const BOOKING_UPDATED = 'booking_updated';
export const PAYMENT_PAGE = 'payment_page';
export const SUMMARY_PAGE = 'summary_page';
export const CHILDCARE_PRESTATIONS_PAGE = 'prestations_page_childcare';
export const SEND_MESSAGE = 'send_message';
export const SHARE_SPONSOR_CODE = 'share_sponsor_code';
export const USE_EXISTING_CARD = 'payment_use_existing_card';
export const USE_NEW_CARD = 'payment_use_new_card';
export const SAVE_NEW_CARD = 'payment_save_new_card';
export const CREATE_NEW_CARD = 'payment_create_new_card';
export const CREATE_CARD_ERROR = 'payment_create_card_error';
export const SCA_CHECK = 'payment_sca_check';
export const SCA_CHECK_SUCCESS = 'payment_sca_check_success';
export const SCA_CHECK_ERROR = 'payment_sca_check_error';
export const DIAGNOSTIC = 'diagnostic';

// Pro events
export const ABSENCE_CREATED = 'absence_created';
export const ABSENCE_UPDATED = 'absence_updated';
export const CHANGE_REQUEST_ACCEPTED = 'change_request_accepted';
export const CHANGE_REQUEST_REFUSED = 'change_request_refused';
export const COUNTER_PROPOSAL_CREATED = 'counter_proposal_created';
export const IBAN_UPDATED = 'iban_updated';
export const MESSAGE_SENT = 'message_sent';
export const OPENING_HOURS_UPDATED = 'opening_hours_updated';
export const ORDER_CANCELLED = 'order_cancelled';
export const ORDER_UPDATED = 'order_updated';
export const PRESTATIONS_UPDATED = 'prestations_updated';
export const PROPOSAL_ACCEPTED = 'proposal_accepted';
export const PROPOSAL_REFUSED = 'proposal_refused';
export const TRANSPORT_SETTINGS_UPDATED = 'transport_settings_updated';
